export const styles = theme => ({
    container: {
        display: "block",
        margin: 10,
    },
    title: {
        "& h3": {
            margin: "1.5rem 0",
        },
        "& h4": {
            margin: "1rem 0"
        },
        margin: "2rem 0",
        "& h5": {
            margin: "0.7rem 0"
        },
        "& h6": {
            margin: "0.7rem 0"
        },
    },
    table: {
        "& allBorder": {
            border: "1px solid #ddd",
            padding: "0.7rem 0"
        },
    },
    section: {
        marginBottom: 32
    },
    link: {
        color: '#000099',
        textDecorationLine: 'underline'
    },
    header: {
        marginBottom: 48
    }
});
